import React from 'react';


const features = [
  {
    id: 1,
    title: 'Real‑time production control',
    description:
      'Manage plant schedules and execute work activities with up‑to‑date production and inventory status. React instantly to unplanned events and minimize downtime.',
    image:"https://ik.imagekit.io/kqumni8l2/MES/MES/real-time-production-control-2-1920x1080.jpeg?updatedAt=1745219448227",
  },
  {
    id: 2,
    title: 'Process & quality monitoring',
    description:
      'Automate quality sample plan execution. Apply Statistical Process Control (SPC) methods to visualize quality data and KPIs in real time. Easily identify samples that violate limits and rules.',
    image:"https://ik.imagekit.io/kqumni8l2/MES/MES/process-and-product-quality-monitoring-1920x1080.jpeg?updatedAt=1745219447921",
  },
  {
    id: 3,
    title: 'Cloud integration',
    description:"Store, share, and visualize execution data in the cloud. Integrate data from multiple plant MES systems. Enrich with data from Infor™ PI System™ and other OT and IT data sources.",
    image:"https://ik.imagekit.io/kqumni8l2/MES/MES/cloud-integration-1920x1080.jpeg?updatedAt=1745219448476",
    },
  {
    id: 4,
    title: ' User experience modeling',
    description:
      'Adopt information views to your work practices with a low-code HTML5 forms designer. Include schedule adherence and real-time OEE KPIs with decision support to maintain production performance and line throughput.',
    image: "https://ik.imagekit.io/kqumni8l2/MES/MES/webiste%20services%20image%20withh%20kcs%20logo.png?updatedAt=1745479128336",
  },
  {
    id: 5,
    title: 'Plant modeling ',
    description:
      'Model your plant processes and business rules. Guide workers with process, product, and quality specification information and validation for the current scheduled job.',
    image: "https://ik.imagekit.io/kqumni8l2/MES/MES/plant-modeling-1920x1080.jpeg?updatedAt=1745219448279",
  },
  {
    id: 6,
    title: 'Digitalization of workflows',
    description:
      'Capture operational procedures and workflows using low-code technology. Automate and ensure correct and consistent workflow execution.',
    image: "https://ik.imagekit.io/kqumni8l2/MES/MES/digitalization-of-workflows-1920x1080.jpeg?updatedAt=1745219448234",
  },
];

const FeaturesSection = () => (
  <section className="bg-[#F7F9FA] py-16 px-4 md:px-8 lg:px-16">
    <h2 className="text-center text-3xl md:text-4xl font-semibold text-[#0D1B2A] mb-12">
      Features
    </h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
      {features.map(({ id, title, description, image }) => (
        <div
          key={id}
          className="bg-white rounded-2xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 overflow-hidden"
        >
          <img
            src={image}
            alt={title}
            className="w-full h-48 object-cover"
          />
          <div className="p-6">
            <h3 className="text-xl font-bold text-[#0D1B2A] mb-2">{title}</h3>
            <p className="text-base text-[#3A3F45] leading-relaxed">
              {description}
            </p>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default FeaturesSection;
